import { get, isEmpty, pick } from 'lodash/fp'
import format from 'date-fns/format'

export default {
  isFetching: (state) => state.isFetching,
  firstName: (state, getters, rootState, rootGetters) =>
    state.firstName || rootGetters['member/firstName'],
  lastName: (state) => state.lastName,
  birthday: (state) => state.birthday,
  guardian: (state) => state.guardian,
  guardianBirthday: (state) => state.guardian.dob,
  registrationPrimarySms: (state) => {
    return state.primarySmsPhone
  },
  registrationPrimaryVoice: (state) => {
    return state.primaryPhone
  },
  registrationEmail: (state) => {
    return state.email
  },
  verifiedRegistrationJwt: (state) => {
    return state.verifiedRegistrationJwt
  },
  registrationInfo: (state) => {
    return {
      clientMemberId: state.memberNumber,
      lastName: state.lastName,
      firstName: state.firstName,
      dob: state.birthday && format(state.birthday, 'yyyy-MM-dd'),
      password: state.password,
      communicationPreferences: state.communicationPreferences,
      smsOptIn: state.smsOptIn,
      guardian: !isEmpty(state.guardian) ? state.guardian : null,
      mfaPreference: state.mfaPreference,
      username: state.username,
      preferredLanguageCd: state.preferredLanguageCd,
    }
  },
  registrationSSOInfo: (state, getters) =>
    pick(['communicationPreferences', 'smsOptIn'])(getters.registrationInfo),
  resetPasswordIsFetching: (state) => state.resetPasswordIsFetching,
  changePasswordFromResetIsFetching: (state) =>
    state.changePasswordFromResetIsFetching,
  databasePreferredLanguageCd: (state) =>
    get('databasePreferredLanguageCd', state),
  mfaPreference: (state) => {
    return state.mfaPreference
  },
}
